import React from 'react';
import DfbHeadline from '../ui-kit/dfb_headline';
import DfbRte from '../ui-kit/dfb_rte';
import Section from "./section"

const MStreet = (props) => {
  return (
    <Section
      baseClass="m-Street"
      data={props.data}
    >
      <div className="m-Street-wrapper">
        <div className="m-Street-container">
          <div className="m-Street-text">
            {props.data.headline &&
              <div className="c-Headline">
                <DfbHeadline headline={props.data.headline} headline_level="h2" add_class="c-Headline-strokeLine" />
              </div>
            }
            {props.data.text &&
              <DfbRte text={props.data.text} add_class="u-Spacing-s" />
            }
          </div>
          <div className="m-Street-videoWrapper">
            <video className="m-Street-video" autoPlay muted poster="https://www.dfb-akademie.de/assets/images/static/spl-unser-weg-animation-poster.png">
              <source src="https://www.dfb-akademie.de/assets/videos/dfb-unser-weg-animation.mp4" type="video/mp4" />
              <p className="dfb-pargraph">Ihr Browser unterstützt kein HTML5 video.</p>
            </video>
          </div>
        </div>
      </div>
    </Section>
  );
}

export default MStreet;

